module.exports = __webpack_public_path__ + "img/e266c4f.jpg";